import { endpoints, request } from '!core/api';

export const authServices = {
  getUserProcess: ({ processId }) =>
    request.get(endpoints.chnn(`wsbGetUserProcess?processId=${processId}`)),
};
